import React from 'react';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import EditIcon from '@mui/icons-material/Edit';
import { getClosed } from '../../helper/setLocalStorage';
import AdjudicatorStatus from '../AdjudicatorStatus/AdjudicatorStatus';


const MainDiv = ({ photo, name, fname, lname, location, collaboratorModal, onDelete, id, from, onEdit, item, accountStatus }) => {
  const url = 'https://icon-library.com/images/no-user-image-icon/no-user-image-icon-29.jpg';
  return (
    <div className={collaboratorModal ? 'AddedAdjCollab mb-3' : 'AddedAdj'}>
      <div className="leftDivAdj ">
        <div className="adjImg mb-1">
          <img src={photo ? photo : url} />
          <div className="adjDes">
            <span className="adjNAme">{fname ? `${fname} ${lname || ""}`.trim() : name}</span>
            <span className="adjCoun">{location}</span>
            {/* Adjudicators who haven't set up their account yet (card 930d3ac0) */}
            {accountStatus && accountStatus !== "active" && (
              <span className="mt-1"><AdjudicatorStatus status={accountStatus} /></span>
            )}
          </div>
        </div>

      </div>
      {from != 'golive'&& (
        <div className='d-flex'>
          {onEdit && <div className="rightDivAdj px-0" onClick={() => onEdit(item, from)}><EditIcon sx={{ color: "#68AD3F !important" }} /></div>}
          <div className="rightDivAdj px-0" onClick={() => { onDelete(id, from); }}><DeleteOutlineIcon /></div>
        </div>
      )}
    </div>
  );
};

export default MainDiv;
